import { render, staticRenderFns } from "./equipment_details.vue?vue&type=template&id=1491d64c&scoped=true&"
import script from "./equipment_details.vue?vue&type=script&lang=js&"
export * from "./equipment_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1491d64c",
  null
  
)

export default component.exports